import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "music-library-offline-note"
}
const _hoisted_2 = {
  key: 1,
  class: "ion-padding empty-hint music-library-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Музыка",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: _normalizeClass(['music-library-content', _ctx.isMobile ? 'main-background' : 'liga-web-background']),
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadFolders($event))),
            disabled: _ctx.globalContext.offlineMode
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content)
            ]),
            _: 1
          }, 8, ["disabled"]),
          (!_ctx.loading && _ctx.folders.length)
            ? (_openBlock(), _createBlock(_component_ion_list, {
                key: 0,
                class: "music-library-list",
                lines: "none"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (f) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: f.id,
                      button: "",
                      detail: false,
                      class: "music-library-folder-item",
                      onClick: ($event: any) => (_ctx.$router.push(`/music-library/${f.id}`))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("h2", null, _toDisplayString(f.title), 1),
                            (f.offlineSaved && !_ctx.globalContext.offlineMode)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Сохранено офлайн"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_icon, {
                          slot: "end",
                          icon: _ctx.chevronForwardOutline,
                          class: "music-library-chevron"
                        }, null, 8, ["icon"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              }))
            : (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.emptyMessage), 1))
              : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ion_spinner, {
                key: 2,
                class: "ion-margin music-library-spinner",
                name: "crescent"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class", "onIonScroll"])
    ]),
    _: 1
  }))
}